export default function getBusinessName() {
  return window?.$dt?.objConfig?.Me?.Portfolio;
}
